import React from 'react';
import './Introduction.css';
import { Button } from './Button';

/* Each band is a heading pinned in the margin, the prose beside it, and a
   large plate below spanning most of the grid. The figures are <img> rather
   than background divs so they render at their own aspect ratio instead of
   being cropped into a fixed box. */
function Introduction(){
    return(
      <div className="intro-container">
        {/* First Section: Text on Left, Image on Right */}
        <section className="intro-section" data-reveal>
          <h2 className="intro-title">Who We Are</h2>
          <div className="intro-text-content">
            <p className="intro-subtitle">
              The TExUS lab is part of the department of earth and planetary sciences at the Jackson School of Geosciences at the University of Texas at Austin.
            </p>
            <p className="intro-subtitle">
              The PI and group members have additional affiliations with various programs and schools across the university (Civil, Architectural & Environmental Engineering, Oden Institute of Computational Sciences and Engineering, Center for Space Research, LBJ School of Public Affairs), and different programs internationally through a UNESCO Chair in Open Systems, Innovative Solutions – AI, Water, & Cities.
            </p>
          </div>
          <img
            className="intro-image"
            src={process.env.PUBLIC_URL + '/images/aaa.jpeg'}
            alt=""
            loading="lazy"
          />
        </section>

        {/* Second Section: Text on Right, Image on Left */}
        <section className="intro-section reverse" data-reveal>
          <h2 className="intro-title">Our Mission</h2>
          <div className="intro-text-content">
            <p className="intro-subtitle">
              We study extreme weather and cities. Our laboratory is particularly interested in developing scientific understanding and creating tools and science for society using satellite datasets, dynamical models and AI/ML approaches.
            </p>
            <p className="intro-subtitle">
              The Lab works on developing digital twins, data-to-decision tools, improving severe & extreme weather forecasting and diagnostics, and  process-scale scientific understanding for building resilient infrastructure.
            </p>
            <div className="button-container">
              <Button buttonStyle="introbtn--primary" buttonSize="introbtn--largest" to="/projects">
                Explore Research
              </Button>
            </div>
          </div>
          <img
            className="intro-image"
            src={process.env.PUBLIC_URL + '/images/Our%20Mission.JPG'}
            alt=""
            loading="lazy"
          />
        </section>
      </div>
    );
}

export default Introduction;
